import { render, staticRenderFns } from "./ProductWindow.vue?vue&type=template&id=0b160897&scoped=true&lang=pug&"
import script from "./ProductWindow.vue?vue&type=script&lang=ts&"
export * from "./ProductWindow.vue?vue&type=script&lang=ts&"
import style0 from "./ProductWindow.vue?vue&type=style&index=0&id=0b160897&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b160897",
  null
  
)

export default component.exports